/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { HTMLAttributes } from 'react'
import { Center, ThemeIcon } from '@mantine/core'

export type NoPhotoProps = HTMLAttributes<HTMLElement> & {
  height: number
  size?: SizeProp
  width?: number
}

function NoPhoto (props: NoPhotoProps) {
  const {
    height,
    size = 'lg',
    width,
    ...others
  } = props
  return (
    <Center
      bg="gray.0"
      {...others}
      style={{ width, height }}
    >
      <ThemeIcon variant="transparent" color="gray">
        <FontAwesomeIcon
          fixedWidth
          icon={faImage}
          size={size}
        />
      </ThemeIcon>
    </Center>
  )
}

export default NoPhoto
